import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Frame from "../layout/Frame";
import Meta from "../layout/Meta";

const NotFound = () => (
  <Frame>
    <Meta title="Not found" />
    <div className="lost">
      <div>
        <div className="fig">404</div>
        <h2>This route returned zero conversions.</h2>
        <p style={{ color: "#6b6b6b", maxWidth: 480, margin: "0 auto 2rem" }}>
          Did not move the dial. Did not move the page. Try the navigation.
        </p>
        <Link to="/" className="btn btn--orange">Back to home <FiArrowRight /></Link>
      </div>
    </div>
  </Frame>
);

export default NotFound;
